import { render, staticRenderFns } from "./BillingProfile.vue?vue&type=template&id=4c9b0e8f&scoped=true"
import script from "./BillingProfile.vue?vue&type=script&lang=js"
export * from "./BillingProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c9b0e8f",
  null
  
)

export default component.exports